<template>
    <div class="group-filter-bg px-md-4 py-md-4">
      <div class="row pt-0 mr-lg-4 justify-content-between">
        <div :class="`col-sm-6 col-xl-${col}`">
          <div class="form-group">
            <input
              v-model.trim="firstNameVacataire"
              id="firstNameVacataire"
              name="firstNameVacataire"
              type="text"
              autofocus
              placeholder="Prénom Vacataire"
              class="form-control"
            />
          </div>
        </div>
        <div :class="`col-sm-6 col-xl-${col}`">
          <div class="form-group">
            <input
              v-model.trim="lastNameVacataire"
              id="lastNameVacataire"
              name="lastNameVacataire"
              type="text"
              autofocus
              placeholder="Nom Vacataire"
              class="form-control"
            />
          </div>
        </div>
        <div :class="`col-sm-6 col-xl-${col}`">
          <div class="form-group">
            <input
              v-model.trim="firstNameDemander"
              id="firstNameDemander"
              name="firstNameDemander"
              type="text"
              autofocus
              placeholder="Prénom Demandeur"
              class="form-control"
            />
          </div>
        </div>
        <div :class="`col-sm-6 col-xl-${col}`">
          <div class="form-group">
            <input
              v-model.trim="lastNameDemander"
              id="lastNameDemander"
              name="lastNameDemander"
              type="text"
              autofocus
              placeholder="Nom Demandeur"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="row pt-0 mr-lg-4 justify-content-between">
        <!-- Group Filter -->
  
        <div
          :class="`col-sm-6 col-xl-${col}`"
          v-if="$route.path != '/personalTasks'"
        >
          <div class="group-filter">
            <div class="form-group">
              <select class="form-control" v-model="selectedStatus">
                <option value="">Statut</option>
                <option
                  v-for="(status, index) in statusList"
                  :value="status"
                  :key="index"
                >
                  {{
                    statusListTranslation[status]
                      ? statusListTranslation[status]
                      : "Contrat à valider"
                  }}
                </option>
              </select>
              <div class="select-down">
                <img
                  class="select-down__icon"
                  src="@/assets/images/down-arrow.svg"
                  alt="Arrow Icon"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          :class="`col-sm-6 col-xl-${col}`"
        >
          <div class="group-filter">
            <div class="form-group">
              <select class="form-control" v-model="selectedStructureID">
                <option value="">Structure</option>
                <option
                  v-for="(structure, index) in structureList"
                  :value="structure.reference"
                  :key="index"
                >
                  {{ structure.name }}
                </option>
              </select>
              <div class="select-down">
                <img
                  class="select-down__icon"
                  src="@/assets/images/down-arrow.svg"
                  alt="Arrow Icon"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Report for Filter -->
        <div :class="`col-sm-6 col-xl-${col} mb-3 mb-md-0`">
          <div class="d-flex common-filter">
            <div class="p-2 icon">
              <i class="far fa-calendar"></i>
            </div>
            <div>
              <d-datepicker id="dateFrom" class="pr-1" v-model="startDate" placeholder="date début" :input-class="['form-control']" :language="fr" small></d-datepicker>
            </div>
          </div>
        </div>
        <!-- Date added -->
        <div :class="`col-sm-6 col-xl-${col} mb-3 mb-xl-0`">
          <div class="d-flex common-filter">
            <div class="p-2 icon">
              <i class="far fa-calendar"></i>
            </div>
            <div>
              <d-datepicker id="dateTo" class="pr-1" v-model="endDate" placeholder="date fin" :input-class="['form-control']" :language="fr" small></d-datepicker>
            </div>
          </div>
        </div>
        <!-- Apply Button -->
        <div :class="`only-desk-top col-sm-6 col-xl-${col} mb-3 mb-md-0 d-flex`">
          <div class="task-manager-apply" style="margin-left: 5px">
            <button class="btn btn-primary" @click="saveSearch()">
              {{ $t("global.apply") }}
            </button>
          </div>
          <div class="task-manager-apply" style="margin-left: 5px">
            <button class="btn btn-primary" @click="refresh()">
              {{ $t("global.reset") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { fr } from "vuejs-datepicker/dist/locale";
  import daysOffType from "../../data/daysOff/daysOffType";
  
  export default {
    data() {
      return {
        selectedStatus: "",
        startDate: null,
        endDate: null,
        type: "",
        daysOffList: daysOffType,
        typesList: Object.keys(daysOffType),
        hideGroupFilter: true,
        fr,
        statusListTranslation: {
          ACCEPTED: "Contract approuvé",
          REFUSED: "Contract rejeté",
          TREATED: "Contract enregistré"
        },
        firstNameDemander: "",
        lastNameDemander: "",
        firstNameVacataire: "",
        lastNameVacataire: "",
        structureList: null,
        selectedStructureID: ""
      };
    },
    props: ["statusList"],
    mounted() {
      // const start = new Date();
      // const end = new Date();
      // const filter = this.$store.state.absenceRequest.filter;
  
      // this.selectedStatus = filter.status ? filter.status : "";
      // if (filter.dates) {
      //   if (filter.dates.from) {
      //     start.setTime(filter.dates.from);
      //   }
  
      //   this.startDate = filter.dates.from ? start : "";
      //   if (filter.dates.to) {
      //     end.setTime(filter.dates.to);
      //   }
      //   this.endDate = filter.dates.to ? end : "";
      // } else {
      //   this.startDate = "";
  
      //   this.endDate = "";
      // }
      // this.type = filter.type ? filter.type : "";
      this.$services.structure
        .findAll()
        .then((response) => {
          console.warn(response.data);
          this.structureList = response.data;
        })
    },
    computed: {
      col() {
        return this.hideGroupFilter ? 3 : 3;
      }
    },
  watch : {
  // startDate(newv,old){
  
  //     this.startDate=newv===null ?old : newv
  
  // }
  // ,
  // endDate(newv,old){
  
  //     this.endDate=newv===null ?old : newv
  
  // }
  },
    methods: {
      saveSearch() {
        const obj = {};
        if (this.firstNameVacataire) {
          obj.firstName = this.firstNameVacataire;
        }
        if (this.lastNameVacataire) {
          obj.lastName = this.lastNameVacataire;
        }
        if (this.firstNameDemander) {
          obj.applicantFirstName = this.firstNameDemander;
        }
        if (this.lastNameDemander) {
          obj.applicantLastName = this.lastNameDemander;
        }
        if (this.selectedStatus !== "") {
          obj.status = this.selectedStatus;
        }
        if (this.startDate !== "") {
          obj.startDate = this.startDate;
        }
        if (this.endDate !== "") {
          obj.endDate = this.endDate;
        }
        if (this.selectedStructureID !== "") {
          obj.structureID = this.selectedStructureID;
        }
        this.$store.dispatch("setFilter", obj);
        this.$root.$emit("searchRequests", obj);
      },
  
      refresh() {
        this.selectedStatus = "";
        this.startDate = "";
        this.endDate = "";
        this.selectedStructureID = "";
        this.firstNameVacataire = "";
        this.lastNameVacataire = "";
        this.firstNameDemander = "";
        this.lastNameDemander = "";
        this.saveSearch();
      }
    }
  };
  </script>
  <style lang="scss">
  .form-control {
    background-color: #fff !important;
  }
  .group-filter {
    position: relative;
    select {
      background: white !important;
      color: black !important;
      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4) !important;
      background-repeat: no-repeat;
      -webkit-appearance: none;
      -moz-appearance: none;
      position: relative;
    }
    .select-down {
      position: absolute;
      right: 10px;
      top: 5px;
      &__icon {
        width: 13px;
      }
    }
  }
  .task-manager-apply {
    .task-manager-btn {
      width: 110px;
      height: 36px;
      border: 0;
      background-color: #4f78e2;
      color: #fff;
      font-family: "SF-Pro-Text";
      border-radius: 3px;
      font-size: 14px;
      margin-right: 15px; //9
      outline: none;
    }
  }
  </style>
  